/* eslint-disable no-underscore-dangle */

import { COMPONENT_TYPE } from '../../../../app/constants/component_type';

xplenty.controller('ComponentEditorDestinationController', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$controller',

  function ($scope, $rootScope, $timeout, $controller) {
    angular.extend(this, $controller('ConnectionStep', { $scope }));
    angular.extend(this, $controller('ComponentBaseStep', { $scope }));
    angular.extend(this, $controller('SchemaMappingStep', { $scope }));

    $scope.connectionStep.active = true;
    $scope.parentSchemas = $scope._default.getParentComponentsSchemas();

    $scope.isComponentValid = function () {
      let isComponentValid = false;

      if ($scope.component.componentType === COMPONENT_TYPE.CLOUD_STORAGE_DESTINATION_COMPONENT) {
        isComponentValid =
          ($scope.componentNameValid && $scope.connectionStep.validate() && $scope.componentBaseStep.validate()) ||
          false;
      } else {
        isComponentValid =
          ($scope.componentNameValid &&
            $scope.connectionStep.validate() &&
            $scope.componentBaseStep &&
            $scope.componentBaseStep.validate() &&
            $scope.schemaMappingStep &&
            $scope.schemaMappingStep.validate()) ||
          false;
      }

      $scope.$parent.saveDisabled = !isComponentValid;

      return isComponentValid;
    };

    $scope.$watch(
      'component',
      function () {
        $timeout(function () {
          $scope.isComponentValid();
        });
      },
      true,
    );
  },
]);
